/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  PaymentMethodDto,
  PaymentMethodMetaModel,
  PaymentMethodVO
} from '@well/company-libs/payment-method/domain-model';
import { Observable } from 'rxjs';
import { AccountStatusPaymentMethodStatusDto } from '@well/domain';
import { EnvironmentService } from '@irian-ro/util-environment';
import { AbstractResourceService, JsonApiResource } from '@irian-ro/abstract-resource';

@Injectable({
  providedIn: 'root'
})

export class PaymentMethodResourceService extends AbstractResourceService<PaymentMethodDto, any, PaymentMethodMetaModel, any>{

  constructor(httpClient: HttpClient, environmentSerivce: EnvironmentService) {
    super(
      httpClient,
      environmentSerivce.getEnvironmentProperty('paymentMethodUrl'),
      PaymentMethodDto,
      <any>null,
      PaymentMethodMetaModel,
      <any>null
    )
  }

  getPaymentMethodTemplate(): Observable<JsonApiResource<PaymentMethodDto, PaymentMethodMetaModel>> {
    return <Observable<JsonApiResource<PaymentMethodDto, PaymentMethodMetaModel>>>this.httpClient?.get(`${this.url}/template`, {headers: this.headers});
  }

  getPaymentMethodTemplateAtSignup(subscriptionTypeUuid: string): Observable<JsonApiResource<PaymentMethodDto, PaymentMethodMetaModel>> {
    return <Observable<JsonApiResource<PaymentMethodDto, PaymentMethodMetaModel>>>this.httpClient?.get(`${this.url}/signup/template`, {headers: this.headers, params: {subscriptionTypeUuid: subscriptionTypeUuid}})
  }

  getPendingPaymentMethodStatus(): Observable<JsonApiResource<AccountStatusPaymentMethodStatusDto | null, any>>{
    return <Observable<JsonApiResource<AccountStatusPaymentMethodStatusDto | null, any>>>this.httpClient?.get(`${this.url}/pending/status`);
  }

  savePaymentMethodAtSignup(dto: PaymentMethodDto): Observable<JsonApiResource<PaymentMethodDto, PaymentMethodMetaModel>> {
    return <Observable<JsonApiResource<PaymentMethodDto, PaymentMethodMetaModel>>>this.httpClient?.post(`${this.url}/signup`, dto, {headers: this.headers})
  }

  unlinkPendingPaymentMethodFromAccountStatus(): Observable<unknown>{
    return <Observable<unknown>>this.httpClient?.post(`${this.url}/pending/unlink-from-account-status`, {});
  }

  confirmPaymentMethod(): Observable<unknown>{
    return this.httpClient?.post(`${this.url}/pending/confirm`, {});
  }

  getCurrentPaymentMethodVO(): Observable<JsonApiResource<PaymentMethodVO, any>>{
    return <Observable<JsonApiResource<PaymentMethodVO, any>>>this.httpClient?.get(`${this.url}/current/vo`);
  }
}
